<template>
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Detalhes do Curso</h6>
      <div class="ms-auto">
        <router-link
          v-if="isAdmin === 1"
          to="/courses"
          class="btn btn-outline-dark"
          title="Listagem de Cursos"
        >
          Listagem de Cursos
        </router-link>
        <router-link
          v-else
          to="/home"
          class="btn btn-outline-dark"
          title="Ir para Tela Inicial"
        >
          Ir para Tela Inicial
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <p><strong>Nome:</strong> {{ course.name }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Aproveitamento Mínimo:</strong>
            {{ course.minimumGrade }}%
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Instrutor: </strong>
            {{ course.instructor }}
          </p>
        </div>
        <div class="col-md-12 col-sm-12">
          <p><strong>Descrição:</strong> {{ course.description }}</p>
        </div>
      </div>
    </div>
  </div>
  <div v-if="course.modules && course.modules.length > 0">
    <div v-for="module in course.modules" :key="module.id" class="card">
      <div class="card-header py-0">
        <h6 class="pt-3 mb-1">{{ module.name }}</h6>
        <p class="text-muted">{{ module.description }}</p>
      </div>
      <div class="card-body">
        <div v-if="module.lessons && module.lessons.length > 0" class="row">
          <div class="col-lg-12">
            <p
              v-for="lesson in module.lessons"
              :key="lesson.id"
              :title="lesson.description"
            >
              <i
                :class="{
                  'ph-monitor-play': lesson.type === '1',
                  'ph-list-bullets': lesson.type === '2',
                  'ph-file-text': lesson.type === '3',
                }"
              />
              <span class="ms-1">{{ lesson.title }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailsCourseWithoutEdit',

  props: {
    course: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isAdmin() {
      return this.$store.getters.user.isAdmin
    },
  },
}
</script>
